import { createSlice } from '@reduxjs/toolkit';
import AxiosAdapter from './AxiosAdapter';
import { MESSAGE } from 'src/app/constant/message';
import { HTTP_GETTYPE, STATUS_API } from '../app/constant/config';

export const getListGeocodeSources = AxiosAdapter.GetHttp(
  'geocodeSlice/getListGeocodeSources',
  '/geocode/sources',
  HTTP_GETTYPE.ALL
);

export const createGeocodeSource = AxiosAdapter.HttpPost(
  'geocodeSlice/createGeocodeSource',
  '/geocode/sources',
  MESSAGE.CREATE_GEOCODE_SOURCE_SUCCESS,
  MESSAGE.CREATE_GEOCODE_SOURCE_FAIL
);

export const updateGeocodeSource = AxiosAdapter.HttpPut(
  'geocodeSlice/updateGeocodeSource',
  '/geocode/sources/',
  MESSAGE.UPDATE_GEOCODE_SOURCE_SUCCESS,
  MESSAGE.UPDATE_GEOCODE_SOURCE_FAIL
);

export const deleteGeocodeSource = AxiosAdapter.HttpDelete(
  'geocodeSlice/deleteGeocodeSource',
  '/geocode/sources',
  MESSAGE.DELETE_GEOCODE_SOURCE_SUCCESS,
  MESSAGE.DELETE_GEOCODE_SOURCE_FAIL
);

export const reloadGeocode = AxiosAdapter.HttpPost(
  'geocodeSlice/reloadGeocode',
  '/geocode/reload',
  MESSAGE.RELOAD_GEOCODE_SUCCESS,
  MESSAGE.RELOAD_GEOCODE_FAIL
);

export const getGeocodeStatus = AxiosAdapter.GetHttp(
  'geocodeSlice/getGeocodeStatus',
  '/geocode/status',
  HTTP_GETTYPE.ALL
);

export const testGeocodeSource = AxiosAdapter.HttpPost(
  'geocodeSlice/testGeocodeSource',
  '/geocode/sources/test',
  null,
  null
);

export const geocodeSlice = createSlice({
  name: 'geocodeSlice',
  initialState: {
    listSources: [],
    supportedTypes: [],
    statusData: null,
    testResult: null,

    error: null,
    statusGet: null,
    statusCreate: null,
    statusDelete: null,
    statusUpdate: null,
    statusReload: null,
    statusGetStatus: null,
    statusTest: null,
    isLoading: false
  },

  reducers: {
    resetChange: state => {
      state.statusGet = null;
      state.statusCreate = null;
      state.statusDelete = null;
      state.statusUpdate = null;
      state.statusReload = null;
      state.statusGetStatus = null;
      state.statusTest = null;
      state.testResult = null;
      state.isLoading = false;
      state.error = null;
    }
  },

  extraReducers: {
    [getListGeocodeSources.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListGeocodeSources.fulfilled]: (state, action) => {
      const payload = action.payload?.payload || {};
      state.statusGet = STATUS_API.SUCCESS;
      state.listSources = payload.sources || [];
      state.supportedTypes = payload.supported_types || [];
      state.isLoading = false;
    },
    [getListGeocodeSources.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [createGeocodeSource.pending]: state => {
      state.statusCreate = STATUS_API.PENDING;
    },
    [createGeocodeSource.fulfilled]: state => {
      state.statusCreate = STATUS_API.SUCCESS;
    },
    [createGeocodeSource.rejected]: (state, action) => {
      state.statusCreate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [deleteGeocodeSource.pending]: state => {
      state.statusDelete = STATUS_API.PENDING;
    },
    [deleteGeocodeSource.fulfilled]: state => {
      state.statusDelete = STATUS_API.SUCCESS;
    },
    [deleteGeocodeSource.rejected]: (state, action) => {
      state.statusDelete = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [updateGeocodeSource.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    [updateGeocodeSource.fulfilled]: state => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },
    [updateGeocodeSource.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [reloadGeocode.pending]: state => {
      state.statusReload = STATUS_API.PENDING;
    },
    [reloadGeocode.fulfilled]: state => {
      state.statusReload = STATUS_API.SUCCESS;
    },
    [reloadGeocode.rejected]: (state, action) => {
      state.statusReload = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [getGeocodeStatus.pending]: state => {
      state.statusGetStatus = STATUS_API.PENDING;
    },
    [getGeocodeStatus.fulfilled]: (state, action) => {
      state.statusGetStatus = STATUS_API.SUCCESS;
      state.statusData = action.payload;
    },
    [getGeocodeStatus.rejected]: (state, action) => {
      state.statusGetStatus = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [testGeocodeSource.pending]: state => {
      state.statusTest = STATUS_API.PENDING;
    },
    [testGeocodeSource.fulfilled]: (state, action) => {
      state.statusTest = STATUS_API.SUCCESS;
      state.testResult = action.payload;
    },
    [testGeocodeSource.rejected]: (state, action) => {
      state.statusTest = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    }
  }
});

export const { resetChange } = geocodeSlice.actions;

export default geocodeSlice.reducer;